import { SAMPLE_CLIENT_ID } from '../ClientRecipients.utils';
export const toClientOptions = (clients)=>clients.map((client)=>({
            clientId: client.clientId(),
            name: client.name()
        }));
export const findClientOption = (options, clientId)=>{
    var _options_find;
    return (_options_find = options.find((option)=>option.clientId === clientId)) !== null && _options_find !== void 0 ? _options_find : null;
};
export const isRealClientSelected = (selectedClientId)=>selectedClientId != null && selectedClientId !== SAMPLE_CLIENT_ID;
export const isSampleSelected = (selectedClientId)=>selectedClientId === SAMPLE_CLIENT_ID;
